export const toDropdownLabels = (values: any) => {
  const options = Object.keys(values).map((key) => ({
    label: values[key],
    value: key,
  }));

  return options;
};

export const alertOptions = [
  {
    label: "Check-Ins",
    value: "CHECK_INS",
  },
  {
    label: "Check-Outs",
    value: "CHECK_OUTS",
  },
  {
    label: "All",
    value: "ALL",
  },
];

export const getFileNameFromPath = (filePath: string) =>
  filePath.slice(filePath.lastIndexOf("/") + 1);

export const getFileExtension = (fileName: string): string | null => {
  const dotIndex = fileName.lastIndexOf('.');
  if (dotIndex === -1) {
    return null;
  }
  return fileName.slice(dotIndex + 1).toLowerCase();
}